<template>
  <a-row :gutter="[8, 8]">
    <a-col :span="24" :xl="18">
      <a-card style="height: 100%">
        <a-row :gutter="[8, 8]" align="middle">
          <a-col :span="24">
            <a-row align="middle" justify="space-between" :gutter="[8, 8]">
              <a-col>
                <a-typography-title :level="4" class="text-gray-8 mb-0">
                  Resumen total
                </a-typography-title>
              </a-col>
              <a-col>
                <a-row :gutter="[8, 8]">
                  <a-col>
                    <a-button
                      :type="values_mode == 0 ? 'primary' : 'default'"
                      @click="values_mode = 0"
                    >
                      Porcentajes
                    </a-button>
                  </a-col>
                  <a-col>
                    <a-button
                      :type="values_mode == 1 ? 'primary' : 'default'"
                      @click="values_mode = 1"
                    >
                      Números
                    </a-button>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24">
            <a-row justify="space-between" align="middle" :gutter="[8, 8]">
              <a-col :xs="12" :sm="11" :md="5">
                <a-typography-text class="text-gray-8 fs-xl d-block">
                  {{ formatNumber(resume_values.solicitudes) }}
                </a-typography-text>
                <a-typography-text class="text-gray-8 fs-sm d-block">
                  Solicitudes
                </a-typography-text>
              </a-col>
              <a-col :span="0" :sm="1">
                <a-divider type="vertical" style="height: 48px" />
              </a-col>
              <a-col :xs="12" :sm="11" :md="5">
                <a-typography-text class="text-gray-8 fs-xl d-block">
                  {{ formatNumber(resume_values.ejecutadas) }}
                </a-typography-text>
                <a-typography-text class="text-gray-8 fs-sm d-block">
                  Ejecutadas
                </a-typography-text>
              </a-col>
              <a-col :xs="0" :sm="0" :md="1">
                <a-divider type="vertical" style="height: 48px" />
              </a-col>
              <a-col :xs="12" :sm="11" :md="5">
                <a-typography-text class="text-gray-8 fs-xl d-block">
                  {{ formatNumber(resume_values.revision) }}
                </a-typography-text>
                <a-typography-text class="text-gray-8 fs-sm d-block">
                  En progreso
                </a-typography-text>
              </a-col>
              <a-col :span="0" :sm="1">
                <a-divider type="vertical" style="height: 48px" />
              </a-col>
              <a-col :xs="12" :sm="11" :md="5">
                <a-typography-text class="text-gray-8 fs-xl d-block">
                  {{ formatNumber(resume_values.canceladas) }}
                </a-typography-text>
                <a-typography-text class="text-gray-8 fs-sm d-block">
                  Canceladas
                </a-typography-text>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
    <a-col :span="24" :xl="6">
      <a-card style="height: 100%">
        <a-row :gutter="[8, 8]">
          <a-col :span="24">
            <a-typography-text class="text-gray-8 fw-semibold">
              Trabajo terminado
              <a-tooltip>
                <template #title>Solicitudes ejecutadas y canceladas</template>
                <InfoCircleOutlined />
              </a-tooltip>
            </a-typography-text>
          </a-col>
          <a-col :span="24">
            <a-progress
              stroke-linecap="square"
              :percent="resume_values.terminado"
            />
          </a-col>
        </a-row>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { computed, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { FETCH_TABLE_RESUME, GETTER_TICKET_TABLE_RESUME } from '../store/types';
import { InfoCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'TableResumeTest',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    InfoCircleOutlined
  },
  setup(props) {
    // * Vuex
    const store = useStore();

    // * Props
    const resume_type = computed(() => props.type);

    // * Llamada principal de data
    watchEffect(async (onCleanUp) => {
      try {
        const ac = new AbortController();
        const signal = ac.signal;
        onCleanUp(() => ac.abort());
        await store.dispatch(FETCH_TABLE_RESUME, {
          payload: resume_type.value,
          signal
        });
      } catch (error) {
        console.log(error);
      }
    });

    // Cálculo de porcentaje
    const calculatePorcentage = (value, total) => {
      return total > 0 ? Math.round((value * 100) / total) : 0;
    };

    // Modo cómo se muestra la data
    // # Porcentajes
    // # Numeros
    // La primera opción es números
    const values_mode = ref(1);

    const resume_values = computed(() => {
      // Valores obtenidos desde el endpoint
      const values = store.getters[GETTER_TICKET_TABLE_RESUME];

      // Cálculo de portencajes de "Trabajo terminado"
      const { ejecutadas, canceladas, tickets, revision } = values;
      // const finished = ((ejecutadas + canceladas) * 100) / tickets;
      const finished = calculatePorcentage(ejecutadas + canceladas, tickets);

      // Transformo todo a un objeto para mostrar los valores
      // Dependiendo del modo en el que estén
      const final = {
        solicitudes: tickets,
        ejecutadas:
          values_mode.value === 0
            ? `${calculatePorcentage(ejecutadas, tickets)}%`
            : ejecutadas,
        canceladas:
          values_mode.value === 0
            ? `${calculatePorcentage(canceladas, tickets)}%`
            : canceladas,
        revision:
          values_mode.value === 0
            ? `${calculatePorcentage(revision, tickets)}%`
            : revision,
        terminado: finished
      };

      return final;
    });

    function formatNumber(number) {
      if (typeof number !== 'number') {
        return number;
      }
      return number ? new Intl.NumberFormat('es-CL').format(number) : 0;
    }

    return {
      resume_type,
      values_mode,
      resume_values,
      formatNumber
    };
  }
};
</script>
